import { OcsDeviceOutlineUrl } from '@icons';
import { ClinicalSection, ClinicalLogItem } from '@features/components/ClinicalData/components';
import { ClinicalItemLog, WithPerfusionTime } from '@features/components/ClinicalData/types';
import { ClinicalData, OrganType } from '@/api/apis/case';

export type ClinicalLogSectionProps = {
  organType: OrganType;
  clinicalData: ClinicalData;
  isTrialCase: boolean;
  clinicalDataItems: WithPerfusionTime<ClinicalItemLog>[];
  sectionColor: string;
  hasChatPermission?: boolean;
};

export const ClinicalLogSection = ({
  organType,
  clinicalData,
  isTrialCase,
  clinicalDataItems,
  sectionColor,
  hasChatPermission = false,
}: ClinicalLogSectionProps) => {
  return (
    <ClinicalSection
      color={sectionColor}
      className="2xl:overflow-y-auto"
      header="Clinical Log"
      icon={OcsDeviceOutlineUrl}
    >
      {clinicalDataItems.length ? (
        <div className="flex flex-col gap-4 self-start" aria-label="items-list">
          {clinicalDataItems.map((clinicalDataItem) => (
            <ClinicalLogItem
              key={`${clinicalDataItem.timestamp}-${clinicalDataItem.clinicalItemType}-${clinicalDataItem.id}`}
              organType={organType}
              record={clinicalDataItem}
              clinicalData={clinicalData}
              isTrialCase={isTrialCase}
              hasChatPermission={hasChatPermission}
            />
          ))}
        </div>
      ) : null}
    </ClinicalSection>
  );
};
